<div class="dialog-header">
  <img src="assets/images/logo.svg" alt="User Avatar" class="user-avatar" />
  <h2>User Details</h2>
</div>

<div mat-dialog-content>
  <form [formGroup]="userForm" class="form-alignment">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Email</mat-label>
      <input type="email" matInput formControlName="email" placeholder="Enter email" [matAutocomplete]="auto"
        (focus)="onEmailFocus()" (selectionChange)="onEmailSelected($event)" />
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let email of filteredEmails | async" [value]="email">
          {{ email }}
        </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="userForm.get('email')?.hasError('required')">
        Email is required
      </mat-error>
      <mat-error *ngIf="userForm.get('email')?.hasError('email')">
        Enter a valid email
      </mat-error>
      <mat-error *ngIf="userForm.get('email')?.hasError('duplicate')">
        This email already exists in the list
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Persona</mat-label>
      <mat-select formControlName="persona">
        <mat-option class="input-styles" *ngFor="let p of personas" [value]="p">
          {{ p.role_name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="userForm.get('persona')?.hasError('required')">
        Persona is required
      </mat-error>
    </mat-form-field>
  </form>
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cancel</button>
  <button [disabled]="buttonDisabledUntilResponse" type="submit" mat-flat-button color="primary" (click)="submit()"
    [disabled]="userForm.invalid">
    Submit
  </button>
</div>